import React from "react"
import classNames from "classnames";

export interface IArrowLeftProps {
    className?: string;
    style?: any;
    width?: number;

}
export const ArrowLeft: React.FC<IArrowLeftProps> = ({ width, style, className }) => {

    return (
        <svg data-testid={"spb-icon-arrow-left"} style={{ fill: "#000000", ...style }} width={width ?? 24} viewBox="0 0 24 24" id="left-arrow" data-name="Flat Line" xmlns="http://www.w3.org/2000/svg" className={classNames("icon flat-line", className)}>
            <g strokeWidth="0"></g>
            <g><polyline id="primary" points="6 9 3 12 6 15" style={{ fill: 'none', stroke: '#000000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 2, ...style }}>
            </polyline></g>
            <line x1="21" y1="12" x2="3" y2="12" style={{ fill: 'none', stroke: '#000000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 2, ...style }}></line>
        </svg>
    )
}